/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_R2_DescriptionInputs */

const en_admin_settings_groups_r2_description = /** @type {(inputs: Admin_Settings_Groups_R2_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Object storage settings`)
};

/**
* | output |
* | --- |
* | "Object storage settings" |
*
* @param {Admin_Settings_Groups_R2_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_r2_description = /** @type {((inputs?: Admin_Settings_Groups_R2_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_R2_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_r2_description(inputs)
});
export { admin_settings_groups_r2_description as "admin.settings.groups.r2.description" }